import {PieceTypes} from '@colonist/game-base-types'
import {CardEnum} from '@colonist/game-states'

export function getCardsForPiece(piece: PieceTypes): CardEnum[] {
    switch(piece) {
        case PieceTypes.City: return [CardEnum.Grain, CardEnum.Grain, CardEnum.Ore, CardEnum.Ore, CardEnum.Ore]
        case PieceTypes.Settlement: return [CardEnum.Lumber, CardEnum.Brick, CardEnum.Wool, CardEnum.Grain]
        case PieceTypes.Road: return [CardEnum.Lumber, CardEnum.Brick]
        case PieceTypes.DevelopmentCard: return [CardEnum.Wool, CardEnum.Grain, CardEnum.Ore]
        case PieceTypes.Ship: return [CardEnum.Lumber, CardEnum.Wool]
        case PieceTypes.CityWall: return [CardEnum.Brick, CardEnum.Brick]
        case PieceTypes.Knight: return [CardEnum.Wool, CardEnum.Ore]
    }
}
